const realisations = [
  {
    src: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20modern%20window%20handle%20mechanism%2C%20professional%20repair%20of%20a%20cremone%20lock%20on%20white%20PVC%20window%2C%20technician%20hands%20working%20with%20precision%20tools%2C%20clean%20bright%20workshop%20environment%2C%20detailed%20hardware%20photography%2C%20warm%20neutral%20tones%2C%20professional%20craftsmanship%20documentation%2C%20soft%20natural%20lighting%2C%20no%20text&width=600&height=450&seq=avis-real-1&orientation=landscape",
    alt: "Remplacement de crémone sur fenêtre PVC à Strasbourg",
    title: "Remplacement de crémone",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Window%20tilt%20and%20turn%20mechanism%20adjustment%2C%20oscillo-battant%20window%20being%20repaired%20with%20specialized%20tools%2C%20modern%20aluminum%20window%20frame%2C%20professional%20repair%20technician%20at%20work%2C%20clean%20indoor%20setting%2C%20bright%20daylight%2C%20detailed%20mechanical%20parts%20visible%2C%20professional%20service%20photography%2C%20warm%20neutral%20tones%2C%20no%20text&width=600&height=450&seq=avis-real-2&orientation=landscape",
    alt: "Réglage d'oscillo-battant à Schiltigheim, Bas-Rhin",
    title: "Réglage oscillo-battant",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Old%20wooden%20window%20frame%20restoration%2C%20traditional%20European%20window%20being%20repaired%2C%20artisan%20working%20on%20wood%20frame%20repair%2C%20historic%20building%20window%20maintenance%2C%20warm%20workshop%20lighting%2C%20craftsmanship%20detail%2C%20natural%20wood%20tones%2C%20professional%20restoration%20photography%2C%20soft%20warm%20background%2C%20no%20text&width=600&height=450&seq=avis-real-3&orientation=landscape",
    alt: "Restauration de fenêtre en bois ancienne à Obernai, Bas-Rhin",
    title: "Restauration bois ancien",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Window%20hinge%20and%20gond%20repair%2C%20paumelle%20replacement%20on%20modern%20window%2C%20professional%20technician%20installing%20new%20window%20hardware%2C%20close-up%20of%20hinge%20mechanism%2C%20clean%20white%20background%2C%20bright%20workshop%20lighting%2C%20precision%20tool%20work%2C%20professional%20repair%20documentation%2C%20warm%20neutral%20colors%2C%20no%20text&width=600&height=450&seq=avis-real-4&orientation=landscape",
    alt: "Remplacement de gond et paumelle à Haguenau, Bas-Rhin",
    title: "Remplacement de gond",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Modern%20window%20handle%20replacement%2C%20new%20white%20handle%20being%20installed%20on%20tilt%20and%20turn%20window%2C%20professional%20repair%20service%2C%20clean%20interior%20setting%2C%20bright%20daylight%20coming%20through%20window%2C%20contemporary%20home%20interior%2C%20warm%20neutral%20color%20palette%2C%20professional%20installation%20photography%2C%20sharp%20detail%2C%20no%20text&width=600&height=450&seq=avis-real-5&orientation=landscape",
    alt: "Changement de poignée de fenêtre à Sélestat, Bas-Rhin",
    title: "Changement de poignée",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Window%20seal%20and%20insulation%20repair%2C%20window%20frame%20being%20adjusted%20for%20better%20closure%2C%20professional%20technician%20fixing%20window%20closing%20mechanism%2C%20energy%20efficiency%20improvement%2C%20modern%20apartment%20interior%2C%20bright%20clean%20setting%2C%20professional%20service%20photography%2C%20soft%20warm%20tones%2C%20detailed%20craftsmanship%2C%20no%20text&width=600&height=450&seq=avis-real-6&orientation=landscape",
    alt: "Réparation de fenêtre qui ferme mal à Lingolsheim, Bas-Rhin",
    title: "Fenêtre qui ferme mal",
  },
];

export default function RealisationsGallery() {
  return (
    <section className="bg-[#EEF2F4] py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-3">
            Nos réalisations
          </h2>
          <p className="text-[#243038] text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Quelques exemples de réparations effectuées sur le terrain dans le Bas-Rhin.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {realisations.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-[#D7E0E4] overflow-hidden group"
            >
              <div className="h-48 md:h-56 overflow-hidden">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-[#1E3A47]">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10 md:mt-12">
          <a
            href="tel:0374471036"
            className="inline-block bg-[#FF6B4A] text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-[#FF6B4A]/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            Appeler le 03 74 47 10 36
          </a>
        </div>
      </div>
    </section>
  );
}